const permissions = [
  {value: "inv", text: "Inventory"},
];
export default permissions;



// WEBPACK FOOTER //
// ./src/StaffRole/permissions.js